import { DateTime } from 'luxon';

export const formatDateTime = (
  value: string | Date | null | undefined,
  format: string,
  empty = '',
): string => {
  if (!value) return empty;

  const dateTime =
    value instanceof Date
      ? DateTime.fromJSDate(value)
      : DateTime.fromISO(value);

  return dateTime.isValid ? dateTime.toFormat(format) : empty;
};

export default formatDateTime;
